// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__E1Wv4","is-visible":"Header_is-visible__QvYNK"};